import HelpIcon from '../../assets/HelpIcon';
import UserIcon from './UserIcon';
import Help from './Help';

const AuthHeader = () => {

	return(
		<div className="authHeader">
			<ul className="innerUl">
				<li>
					<Help />
				</li>
				<li>
					<UserIcon />
				</li>
			</ul>
		</div>
	)
}

export default AuthHeader;